export default "__VITE_ASSET__0e58a91b__"